import type { FindTourOperatorAssignmentsInput } from '@travel-planner/shared/schemas/operations';
import { trpc } from '@/shared/api/trpc';

type Options = {
  enabled?: boolean;
};

export const useTourOperatorAssignmentsData = (
  input: FindTourOperatorAssignmentsInput,
  options?: Options
) =>
  trpc.operations.tourOperatorAssignments.useQuery(input, {
    enabled: options?.enabled ?? true,
  });
